import { useEffect, useState } from "react";
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --gold:#C9A84C;--gold-light:#E8C97A;--gold-dim:#8A6E30;
    --black:#0A0A08;--surface:#161614;--card:#1C1C19;
    --white:#F5F2EC;--dim:#B8B4A8;--muted:#6B6860;
    --serif:'Cormorant Garamond',Georgia,serif;--sans:'Outfit',sans-serif;
  }
  html{scroll-behavior:smooth}
  body{background:var(--black);color:var(--white);font-family:var(--sans);font-weight:300;line-height:1.7;overflow-x:hidden}
  a{color:inherit;text-decoration:none}
  .c{max-width:1100px;margin:0 auto;padding:0 48px}
  nav{position:fixed;top:0;left:0;right:0;z-index:100;padding:16px 0;border-bottom:1px solid rgba(201,168,76,0.1);backdrop-filter:blur(16px);background:rgba(10,10,8,0.92);transition:padding 0.3s}
  .nav-inner{max-width:1100px;margin:0 auto;padding:0 48px;display:flex;align-items:center;justify-content:space-between}
  .nav-logo{font-family:var(--serif);font-size:22px;font-weight:500;color:var(--gold);letter-spacing:0.04em}
  .nav-links{display:flex;gap:32px;align-items:center}
  .nav-links a{font-size:12px;letter-spacing:0.1em;text-transform:uppercase;color:var(--dim);transition:color 0.2s}
  .nav-links a:hover{color:var(--gold)}
  .nav-cta{border:1px solid var(--gold) !important;color:var(--gold) !important;padding:9px 22px;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;transition:all 0.25s}
  .nav-cta:hover{background:var(--gold) !important;color:var(--black) !important}
  .hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;background:none;border:none;padding:4px}
  .hamburger span{display:block;width:24px;height:1.5px;background:var(--gold);transition:all 0.3s}
  .hamburger.open span:nth-child(1){transform:translateY(6.5px) rotate(45deg)}
  .hamburger.open span:nth-child(2){opacity:0}
  .hamburger.open span:nth-child(3){transform:translateY(-6.5px) rotate(-45deg)}
  .mobile-menu{display:none;position:fixed;inset:0;background:rgba(10,10,8,0.98);z-index:99;flex-direction:column;align-items:center;justify-content:center;gap:40px}
  .mobile-menu.open{display:flex}
  .mobile-menu a{font-family:var(--serif);font-size:28px;font-weight:300;color:var(--dim);transition:color 0.2s}
  .mobile-menu a:hover{color:var(--gold)}
  .mobile-cta{font-family:var(--sans) !important;font-size:13px !important;font-weight:500 !important;letter-spacing:0.12em !important;text-transform:uppercase;border:1px solid var(--gold);color:var(--gold) !important;padding:14px 36px;margin-top:8px}
  #hero{min-height:100vh;display:flex;align-items:center;padding-top:90px;position:relative;overflow:hidden}
  .hero-glow{position:absolute;top:0;right:0;width:55%;height:100%;background:radial-gradient(ellipse at top right,rgba(201,168,76,0.07),transparent 65%);pointer-events:none}
  .hero-grid-bg{position:absolute;inset:0;background-image:linear-gradient(rgba(201,168,76,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,0.03) 1px,transparent 1px);background-size:80px 80px;pointer-events:none;mask-image:radial-gradient(ellipse at 70% 50%,black 30%,transparent 70%)}
  .hero-grid{display:grid;grid-template-columns:1.1fr 0.9fr;gap:80px;align-items:center;position:relative}
  .ey{font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:var(--gold);font-weight:500;margin-bottom:20px;display:flex;align-items:center;gap:12px}
  .ey::before{content:'';display:block;width:20px;height:1px;background:var(--gold)}
  .tag{display:inline-block;background:rgba(201,168,76,0.08);border:1px solid rgba(201,168,76,0.2);color:var(--gold);font-size:10px;letter-spacing:0.16em;text-transform:uppercase;padding:5px 14px;margin-bottom:28px}
  h1{font-family:var(--serif);font-size:clamp(48px,5.5vw,76px);font-weight:300;line-height:1.07;color:var(--white);margin-bottom:22px;letter-spacing:-0.01em}
  h1 em{font-style:italic;color:var(--gold)}
  .hero-sub{font-size:15px;color:var(--dim);line-height:1.85;max-width:460px;margin-bottom:40px}
  .acts{display:flex;gap:14px;flex-wrap:wrap}
  .bp{background:var(--gold);color:var(--black);padding:14px 28px;font-size:12px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;display:inline-block;transition:background 0.2s;cursor:pointer;border:1px solid var(--gold)}
  .bp:hover{background:var(--gold-light)}
  .bg{border:1px solid rgba(201,168,76,0.35);color:var(--dim);padding:13px 28px;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;display:inline-block;transition:all 0.2s;cursor:pointer}
  .bg:hover{border-color:var(--gold);color:var(--gold)}
  .eco{background:var(--surface);border:1px solid rgba(201,168,76,0.12);padding:32px}
  .eco-title{font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:var(--gold-dim);margin-bottom:20px}
  .eco-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(201,168,76,0.08)}
  .eco-node{background:var(--surface);padding:18px 14px;text-align:center;transition:background 0.2s;cursor:default}
  .eco-node:hover,.eco-center{background:var(--card)}
  .eco-icon{font-size:20px;margin-bottom:8px}
  .eco-label{font-size:10px;color:var(--muted);letter-spacing:0.04em}
  .eco-center .eco-label{color:var(--gold);font-weight:500}
  .eco-pulse{width:8px;height:8px;background:var(--gold);border-radius:50%;margin:0 auto 8px;animation:pulse 2s ease-in-out infinite}
  @keyframes pulse{0%,100%{opacity:0.3;transform:scale(0.8)}50%{opacity:1;transform:scale(1.2)}}
  .ticker{background:var(--gold);padding:12px 0;overflow:hidden}
  .ticker-inner{display:flex;white-space:nowrap;animation:tick 25s linear infinite}
  .ticker-item{font-size:11px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:var(--black);padding:0 32px}
  @keyframes tick{from{transform:translateX(0)}to{transform:translateX(-50%)}}
  section{padding:100px 0}
  .sec-dark{background:var(--surface)}
  h2{font-family:var(--serif);font-size:clamp(34px,3.8vw,50px);font-weight:300;color:var(--white);line-height:1.12;margin-bottom:16px}
  h2 em{font-style:italic;color:var(--gold)}
  .ssub{font-size:16px;color:var(--dim);line-height:1.8;max-width:640px}
  .diff-grid{display:grid;grid-template-columns:1.2fr 0.8fr;gap:64px;align-items:start;margin-top:48px}
  .stack-nodes{display:flex;flex-direction:column;gap:1px}
  .stack-node{background:var(--card);border-left:2px solid transparent;padding:18px 22px;display:flex;align-items:flex-start;gap:14px;transition:all 0.25s;cursor:default}
  .stack-node:hover{border-left-color:var(--gold)}
  .node-dot{width:7px;height:7px;border-radius:50%;background:rgba(201,168,76,0.25);flex-shrink:0;margin-top:6px;transition:background 0.25s}
  .stack-node:hover .node-dot{background:var(--gold)}
  .node-text{font-size:13px;color:var(--dim);line-height:1.6}
  .node-text strong{color:var(--white);font-weight:500}
  .stat-block{margin-bottom:28px}
  .stat-num{font-family:var(--serif);font-size:56px;font-weight:300;color:var(--gold);line-height:1;margin-bottom:6px}
  .stat-desc{font-size:12px;color:var(--muted);line-height:1.6}
  .diff-quote{border-left:2px solid var(--gold);padding-left:20px;margin-top:32px}
  .diff-quote p{font-family:var(--serif);font-size:16px;font-style:italic;color:var(--dim);line-height:1.75}
  .tracks{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1);margin-top:48px}
  .track{padding:40px 32px;position:relative;overflow:hidden;transition:background 0.25s}
  .track-left{background:var(--surface)}
  .track-right{background:var(--black)}
  .track:hover{background:var(--card)}
  .track::after{content:'';position:absolute;bottom:0;left:0;right:0;height:2px;background:var(--gold);transform:scaleX(0);transform-origin:left;transition:transform 0.35s}
  .track:hover::after{transform:scaleX(1)}
  .track-eyebrow{font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:var(--gold-dim);margin-bottom:16px}
  .track h3{font-family:var(--serif);font-size:24px;font-weight:400;color:var(--white);margin-bottom:12px;line-height:1.2}
  .track-desc{font-size:14px;color:var(--muted);line-height:1.75;margin-bottom:20px}
  .track-bullets{list-style:none;display:flex;flex-direction:column;gap:9px;margin-bottom:24px}
  .track-bullets li{font-size:13px;color:var(--dim);display:flex;gap:9px;line-height:1.55}
  .track-bullets li::before{content:'→';color:var(--gold);flex-shrink:0}
  .track-link{font-size:11px;letter-spacing:0.08em;text-transform:uppercase;color:var(--gold);border-bottom:1px solid rgba(201,168,76,0.3);padding-bottom:2px;display:inline-block}
  .perf-bar{background:rgba(201,168,76,0.04);border:1px solid rgba(201,168,76,0.15);border-left:3px solid var(--gold);padding:20px 28px;margin-top:24px}
  .perf-bar p{font-size:13px;color:var(--dim);line-height:1.75}
  .perf-bar strong{color:var(--gold);font-weight:500}
  .ba{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1);margin-top:48px}
  .ba-col{padding:32px 28px}
  .ba-before{background:var(--card)}
  .ba-after{background:var(--surface)}
  .ba-label{font-size:10px;letter-spacing:0.14em;text-transform:uppercase;margin-bottom:20px;display:flex;align-items:center;gap:8px}
  .ba-dot{width:6px;height:6px;border-radius:50%}
  .ba-items{display:flex;flex-direction:column;gap:12px}
  .ba-item{font-size:13px;color:var(--dim);display:flex;gap:10px;align-items:flex-start;line-height:1.55}
  .ba-x{color:#555;flex-shrink:0;margin-top:1px}
  .ba-check{color:var(--gold);flex-shrink:0;margin-top:1px}
  .about-grid{display:grid;grid-template-columns:1fr 1.6fr;gap:72px;align-items:start;margin-top:56px}
  .portrait{background:var(--card);border:1px solid rgba(201,168,76,0.12);padding:40px;min-height:360px;position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end}
  .portrait::before{content:'"AS"';position:absolute;top:-20px;right:-10px;font-family:var(--serif);font-size:180px;font-weight:300;color:rgba(201,168,76,0.04);line-height:1;pointer-events:none}
  .portrait-name{font-family:var(--serif);font-size:26px;font-weight:400;color:var(--white);margin-bottom:6px}
  .portrait-role{font-size:11px;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;margin-bottom:24px}
  .portrait-divider{height:1px;background:rgba(201,168,76,0.2);margin-bottom:20px}
  .portrait-meta{font-size:12px;color:var(--muted);line-height:1.7}
  .bio{font-size:15px;color:var(--dim);line-height:1.85;margin-bottom:40px}
  .bio p{margin-bottom:18px}
  .bio p:last-child{margin-bottom:0}
  .bio strong{color:var(--white);font-weight:500}
  .stats-row{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1)}
  .stat{background:var(--card);padding:28px 20px;text-align:center}
  .stat-n{font-family:var(--serif);font-size:38px;font-weight:300;color:var(--gold);line-height:1;margin-bottom:8px}
  .stat-l{font-size:12px;color:var(--muted);line-height:1.5}
  .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.1);margin-top:48px}
  .step{background:var(--black);padding:44px 32px}
  .step-num{font-family:var(--serif);font-size:64px;font-weight:300;color:rgba(201,168,76,0.12);line-height:1;margin-bottom:20px;display:block}
  .step-title{font-family:var(--serif);font-size:24px;font-weight:400;color:var(--white);margin-bottom:12px}
  .step-desc{font-size:13px;color:var(--muted);line-height:1.8}
  .contact-glow{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:700px;height:400px;background:radial-gradient(ellipse,rgba(201,168,76,0.06),transparent 70%);pointer-events:none}
  .contact-wrap{text-align:center;max-width:580px;margin:0 auto;position:relative}
  .contact-wrap h2{margin-bottom:16px}
  .contact-wrap p{font-size:15px;color:var(--dim);margin-bottom:44px;line-height:1.8}
  .cdiv{width:1px;height:44px;background:linear-gradient(to bottom,transparent,rgba(201,168,76,0.4));margin:0 auto 44px}
  footer{background:#0D0D0B;border-top:1px solid rgba(201,168,76,0.08);padding:48px 0 28px}
  .footer-grid{display:grid;grid-template-columns:1.2fr 1fr 1fr;gap:48px;margin-bottom:40px}
  .footer-logo{font-family:var(--serif);font-size:20px;color:var(--gold);margin-bottom:10px}
  .footer-tagline{font-size:12px;color:var(--muted);line-height:1.7;max-width:220px}
  .footer-col h4{font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--gold);margin-bottom:16px}
  .footer-col p,.footer-col a{font-size:12px;color:var(--muted);line-height:1.9;display:block;transition:color 0.2s}
  .footer-col a:hover{color:var(--gold)}
  .footer-bottom{border-top:1px solid rgba(201,168,76,0.06);padding-top:24px;display:flex;justify-content:space-between;align-items:center}
  .footer-copy{font-size:11px;color:var(--muted)}
  .r{opacity:0;transform:translateY(22px);transition:opacity 0.7s ease,transform 0.7s ease}
  .r.v{opacity:1;transform:none}
  .d1{transition-delay:0.1s}.d2{transition-delay:0.2s}.d3{transition-delay:0.3s}
  @media(max-width:768px){
    .c{padding:0 24px}
    .hero-grid,.diff-grid,.tracks,.ba,.about-grid,.steps,.stats-row{grid-template-columns:1fr}
    .nav-links{display:none}
    .hamburger{display:flex;margin-left:auto}
    h1{font-size:40px}
    .eco{display:none}
    .footer-grid{grid-template-columns:1fr}
  }
`;
const TICKERS = ["Revenue Expansion", "· Product Modernization", "· Yield Optimization", "· DOOH Bundling", "· Programmatic Strategy", "· Inventory Monetization", "· Channel Expansion", "· Performance Systems ·"];
function setMetaTag(name: string, content: string) {
  let el = document.querySelector('meta[name="' + name + '"]') as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}
function setOGTag(property: string, content: string) {
  let el = document.querySelector('meta[property="' + property + '"]') as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "AdStack Alpha — OOH & DOOH Revenue Advisory";
    setMetaTag("description", "AdStack Alpha helps OOH/DOOH operators and agencies unlock more revenue from their existing advertising infrastructure. Full-stack adtech advisory. Paid on results.");
    setOGTag("og:title", "AdStack Alpha — OOH & DOOH Revenue Advisory");
    setOGTag("og:description", "We help OOH/DOOH operators and agencies unlock more revenue from their existing infrastructure. Operator-led. Paid on results.");
    setOGTag("og:type", "website");
    setOGTag("og:url", "https://adstackalpha.com");
    const style = document.createElement("style");
    style.textContent = STYLES;
    document.head.appendChild(style);
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add("v");
    }), {
      threshold: 0.1
    });
    document.querySelectorAll(".r").forEach(el => obs.observe(el));
    const handleScroll = () => {
      const n = document.querySelector("nav");
      if (n) (n as HTMLElement).style.padding = window.scrollY > 60 ? "10px 0" : "16px 0";
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.head.removeChild(style);
      obs.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const toggleMenu = () => {
    setMenuOpen(prev => {
      document.body.style.overflow = !prev ? "hidden" : "";
      return !prev;
    });
  };
  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = "";
  };
  const CALENDLY = "https://calendly.com/abhishek-adstackalpha/30min";
  return <div style={{
    background: "#0A0A08",
    minHeight: "100vh"
  }}>

      {/* NAV */}
      <nav>
        <div className="nav-inner">
          <div className="nav-logo">AdStack Alpha</div>
          <div className="nav-links">
            <a href="#ooh">For OOH Operators</a>
            <a href="#agency">For Agencies</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
            <a href={CALENDLY} target="_blank" rel="noopener noreferrer" className="nav-cta">Book a Strategy Call</a>
          </div>
          <button className={"hamburger" + (menuOpen ? " open" : "")} onClick={toggleMenu} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={"mobile-menu" + (menuOpen ? " open" : "")}>
        <a href="#ooh" onClick={closeMenu}>For OOH Operators</a>
        <a href="#agency" onClick={closeMenu}>For Agencies</a>
        <a href="#about" onClick={closeMenu}>About</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>
        <a href={CALENDLY} target="_blank" rel="noopener noreferrer" className="mobile-cta" onClick={closeMenu}>Book a Strategy Call</a>
      </div>

      {/* HERO */}
      <section id="hero">
        <div className="hero-glow" />
        <div className="hero-grid-bg" />
        <div className="c">
          <div className="hero-grid">
            <div>
              <div className="ey r">Full-Stack Adtech Advisory</div>
              <div className="tag r d1">We get paid on results — not hours</div>
              <h1 className="r d1">Your advertising<br />infrastructure is worth<br /><em>more</em> than it earns.</h1>
              <p className="hero-sub r d2">AdStack Alpha works with OOH/DOOH operators and digital agencies to unlock revenue from what they already have — bringing cross-stack expertise across DSPs, SSPs, DMPs, and programmatic to every engagement.</p>
              <div className="acts r d3">
                <a href="#ooh" className="bp">I run an OOH/DOOH operation</a>
                <a href="#agency" className="bg">I run an agency</a>
              </div>
            </div>
            <div className="r d2">
              <div className="eco">
                <div className="eco-title">The AdStack Alpha expertise layer</div>
                <div className="eco-grid">
                  {[["📡", "DSPs"], ["center", "AdStack Alpha"], ["📊", "SSPs"], ["🏙️", "OOH / DOOH"], ["🎯", "DMPs"], ["📱", "Mobile / CTV"], ["🏢", "Agencies"], ["⚙️", "Self-Serve"], ["📍", "Location"]].map(([icon, label], i) => icon === "center" ? <div key={i} className="eco-node eco-center">
                        <div className="eco-pulse" />
                        <div className="eco-label">{label}</div>
                      </div> : <div key={i} className="eco-node">
                        <div className="eco-icon">{icon}</div>
                        <div className="eco-label">{label}</div>
                      </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TICKER */}
      <div className="ticker">
        <div className="ticker-inner">
          {[...TICKERS, ...TICKERS].map((t, i) => <span key={i} className="ticker-item">{t}</span>)}
        </div>
      </div>

      {/* DIFFERENTIATOR */}
      <section className="sec-dark">
        <div className="c">
          <div className="ey r">The Differentiator</div>
          <h2 className="r d1">Most consultants know one layer.<br /><em>We know the stack.</em></h2>
          <p className="ssub r d1">That is the actual advantage. DSPs, SSPs, DMPs, OOH/DOOH, self-serve, agencies, SMBs — we have operated across all of them. That full-stack perspective is what gets applied to your specific revenue problem.</p>
          <div className="diff-grid">
            <div className="stack-nodes r d1">
              {[["Demand side", "DSP strategy, audience targeting, bid optimization"], ["Supply side", "SSP integration, yield management, floor pricing"], ["Data layer", "DMP architecture, audience segmentation, measurement"], ["OOH / DOOH", "Inventory modernization, programmatic access, digital bundling"], ["Agency operations", "Channel expansion, packaging, go-to-market"], ["SMB and local", "Performance campaigns, foot traffic, CTV and mobile"]].map(([title, desc], i) => <div key={i} className="stack-node">
                  <div className="node-dot" />
                  <div className="node-text"><strong>{title}</strong> — {desc}</div>
                </div>)}
            </div>
            <div className="r d2">
              {[["10+", "Years operating inside the stack — not advising from outside it"], ["100+", "Agencies helped grow revenue across North America, EMEA, JAPAC and ANZ"], ["20+", "Published research papers in adtech and marketing intelligence"]].map(([num, desc], i) => <div key={i} className="stat-block">
                  <div className="stat-num">{num}</div>
                  <div className="stat-desc">{desc}</div>
                </div>)}
              <div className="diff-quote">
                <p>We do not consult on adtech. We operate it — and we apply that to your specific revenue problem.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OOH */}
      <section id="ooh">
        <div className="c">
          <div className="ey r">For OOH / DOOH Operators</div>
          <h2 className="r d1">You have the inventory.<br /><em>We will help you make more from it.</em></h2>
          <p className="ssub r d2" style={{
          marginBottom: 0
        }}>The OOH landscape has shifted. Programmatic buyers, DOOH networks, and data-driven campaigns are now table stakes — but most independent operators are still packaging and selling inventory the same way they did a decade ago. The result: unsold impressions, commoditized pricing, and agencies going around you to buy programmatically. We fix that — and we only win when you do.</p>
          <div className="tracks">
            <div className="track track-left r d1">
              <div className="track-eyebrow">Revenue Expansion</div>
              <h3>Inventory that earns what it is actually worth</h3>
              <p className="track-desc">We identify what is undersold, mis-priced, or invisible to programmatic buyers — and quantify the gap before we see our fee.</p>
              <ul className="track-bullets">
                <li>Inventory monetization and yield optimization</li>
                <li>Programmatic access and SSP integration</li>
                <li>Revenue packaging and pricing restructure</li>
              </ul>
              <a href="https://adstackalpha.com/ooh-mobile-solution/" target="_blank" rel="noopener noreferrer" className="track-link">See The Second Touch</a>
            </div>
            <div className="track track-right r d2">
              <div className="track-eyebrow">Market Position</div>
              <h3>Compete on value, not just price and impressions</h3>
              <p className="track-desc">We rebuild how you position and sell — so agencies come to you instead of around you, and advertisers renew because results justify it.</p>
              <ul className="track-bullets">
                <li>Digital layer and DOOH bundling strategy</li>
                <li>Agency and buyer relationship development</li>
                <li>Product modernization and new offer design</li>
              </ul>
              <a href="#contact" className="track-link">Talk to us about your inventory</a>
            </div>
          </div>
          <div className="perf-bar r">
            <p><strong>On performance:</strong> We structure engagements around measurable outcomes. In select cases we offer success-fee-only arrangements — we get paid on the incremental revenue we generate, not the time we log.</p>
          </div>
        </div>
      </section>

      {/* BEFORE / AFTER */}
      <section className="sec-dark">
        <div className="c">
          <div className="ey r">The Gap We Close</div>
          <h2 className="r d1">Where most operators <em>are</em> vs. where they could be.</h2>
          <div className="ba r d1">
            <div className="ba-col ba-before">
              <div className="ba-label" style={{
              color: "var(--muted)"
            }}>
                <div className="ba-dot" style={{
                background: "var(--muted)"
              }} />
                Before AdStack Alpha
              </div>
              <div className="ba-items">
                {["Static rate cards, unchanged for years", "No programmatic access or SSP connection", "Selling impressions with no measurement story", "Agencies bypassing you to buy direct", "Unsold inventory with no digital extension"].map((t, i) => <div key={i} className="ba-item"><span className="ba-x">✗</span>{t}</div>)}
              </div>
            </div>
            <div className="ba-col ba-after">
              <div className="ba-label" style={{
              color: "var(--gold)"
            }}>
                <div className="ba-dot" style={{
                background: "var(--gold)"
              }} />
                After AdStack Alpha
              </div>
              <div className="ba-items">
                {["Premium pricing backed by outcome data", "Programmatic demand actively bidding on your inventory", "Measurable results your advertisers renew for", "Direct agency relationships at the right level", "Digital layer turning one impression into a full campaign"].map((t, i) => <div key={i} className="ba-item"><span className="ba-check">✓</span>{t}</div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AGENCY */}
      <section id="agency">
        <div className="c">
          <div className="ey r">For Agencies</div>
          <h2 className="r d1">Your clients want channels<br />that produce results.<br /><em>We help you deliver them.</em></h2>
          <p className="ssub r d2" style={{
          marginBottom: 0
        }}>Most digital agencies are strong where they already operate: Google, Meta, SEO, email. But clients are increasingly asking for more — and agencies that cannot answer that question lose mandates to ones that can. CTV. DOOH. Mobile. Programmatic audio. AdStack Alpha helps you build, pitch, and deliver these channels so you grow client relationships instead of defending them.</p>
          <div className="tracks" style={{
          marginTop: "48px"
        }}>
            <div className="track track-left r d1">
              <div className="track-eyebrow">Channel Expansion</div>
              <h3>New revenue from what your clients are already spending on</h3>
              <p className="track-desc">We audit your client base, identify exactly which channels could improve their results, and help you build the offer.</p>
              <ul className="track-bullets">
                <li>Channel audit and opportunity mapping</li>
                <li>New offer development and pricing</li>
                <li>Pitch and proposal support</li>
              </ul>
              <a href="#contact" className="track-link">Map your opportunities</a>
            </div>
            <div className="track track-right r d2">
              <div className="track-eyebrow">Execution Support</div>
              <h3>Deliver results without building capability in-house</h3>
              <p className="track-desc">Want to close the mandate first and figure out delivery second? We act as your backend — and own the outcome.</p>
              <ul className="track-bullets">
                <li>Campaign execution and performance delivery</li>
                <li>Client-facing results reporting</li>
                <li>Ongoing channel optimization</li>
              </ul>
              <a href="#contact" className="track-link">Talk about your clients</a>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="sec-dark">
        <div className="c">
          <div className="ey r">About</div>
          <h2 className="r d1">Built by someone who has operated<br />at every layer of the ad stack.</h2>
          <div className="about-grid">
            <div className="r d1">
              <div className="portrait">
                <div style={{
                marginBottom: "auto"
              }}>
                  <div style={{
                  fontFamily: "var(--serif)",
                  fontSize: "64px",
                  fontWeight: 300,
                  color: "rgba(201,168,76,0.12)",
                  lineHeight: 1,
                  marginBottom: "24px"
                }}>AS</div>
                </div>
                <div>
                  <div className="portrait-name">Abhishek Shetty</div>
                  <div className="portrait-role">Founder, AdStack Alpha</div>
                  <div className="portrait-divider" />
                  <div className="portrait-meta">
                    Adtech operator. Not a consultant.<br />
                    10 years. DSPs, SSPs, DMPs.<br />
                    North America · EMEA · JAPAC · ANZ.
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="bio r d2">
                <p>AdStack Alpha is led by Abhishek Shetty — a decade inside adtech, not consulting from the outside. He has built and managed global client relationships across North America, EMEA, JAPAC, and ANZ, with deep hands-on experience operating at every layer of the programmatic stack: DSPs, SSPs, and DMPs.</p>
                <p>He has a track record of introducing agency partners into new markets and launching new products from zero. Over his career, he has helped <strong>100+ agencies</strong> and <strong>1,000+ SMBs</strong> grow their advertising revenue — across verticals including restaurants, retail, QSR, e-commerce, healthcare, legal, events, political, hospitality, real estate, and education.</p>
                <p>He has <strong>20+ published research papers</strong> in adtech and marketing intelligence. AdStack Alpha is not a generalist strategy shop. It is deep operator expertise applied to your specific revenue problem — and we structure every engagement around the results we produce.</p>
              </div>
              <div className="stats-row r d3">
                {[["10+", "Years operating inside the stack"], ["100+", "Agencies helped grow revenue"], ["20+", "Published adtech research papers"]].map(([n, l], i) => <div key={i} className="stat">
                    <div className="stat-n">{n}</div>
                    <div className="stat-l">{l}</div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section>
        <div className="c">
          <div className="ey r">How It Works</div>
          <h2 className="r d1">Three steps. <em>Paid on results.</em></h2>
          <div className="steps">
            {[["01", "Audit", "We go deep on your current setup — inventory, pricing, channel mix, client base. We find the gaps and quantify what they are costing you. You know the impact before we see a fee."], ["02", "Roadmap", "A prioritized action plan tied to specific revenue outcomes. You know exactly what we are doing, why, and what it should produce. No ambiguity, no billable mystery hours."], ["03", "Execute", "We implement alongside you and own the outcomes. Our fees are tied to the results we generate — not the hours we log. We win when you win."]].map(([num, title, desc], i) => <div key={i} className={"step r" + (i > 0 ? " d" + i : "")}>
                <span className="step-num">{num}</span>
                <div className="step-title">{title}</div>
                <div className="step-desc">{desc}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="sec-dark" style={{
      position: "relative",
      overflow: "hidden"
    }}>
        <div className="contact-glow" />
        <div className="c">
          <div className="contact-wrap">
            <div className="ey r" style={{
            justifyContent: "center"
          }}>Get In Touch</div>
            <h2 className="r d1">Let us talk about what<br /><em>results</em> should look like.</h2>
            <div className="cdiv r d2" />
            <p className="r d2">A 30-minute conversation is enough to identify the gap and whether there is a fit. No pitch. No deck. Just a direct conversation about your operation and what it should be producing.</p>
            <a href={CALENDLY} target="_blank" rel="noopener noreferrer" className="bp r d3">Book a 30-minute strategy call</a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="c">
          <div className="footer-grid">
            <div>
              <div className="footer-logo">AdStack Alpha</div>
              <div className="footer-tagline">Full-stack adtech advisory. Operator-led. Paid on results.</div>
            </div>
            <div className="footer-col">
              <h4>Contact</h4>
              <a href="mailto:info@adstackalpha.com">info@adstackalpha.com</a>
              <p style={{
              marginTop: "12px"
            }}>447 Broadway, 2nd Floor<br />Suite #3271<br />New York, NY 10013<br />United States</p>
            </div>
            <div className="footer-col">
              <h4>Navigate</h4>
              <a href="#ooh">For OOH Operators</a>
              <a href="#agency">For Agencies</a>
              <a href="https://adstackalpha.com/ooh-mobile-solution/" target="_blank" rel="noopener noreferrer">The Second Touch</a>
              <a href={CALENDLY} target="_blank" rel="noopener noreferrer">Book a Strategy Call</a>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-copy">2025 AdStack Alpha LLC. All rights reserved. Wyoming LLC. New York, NY</div>
            <div className="footer-copy" style={{
            color: "rgba(201,168,76,0.35)",
            fontSize: "10px",
            letterSpacing: "0.06em"
          }}>ADSTACKALPHA.COM</div>
          </div>
        </div>
      </footer>

    </div>;
}